export default __webpack_public_path__ + "static/media/climbing-steps.e39f5c36.jpg";